export default `
<div>
  <p>
    <span style="text-decoration: underline">If you have an ID card:</span>
    <span> please provide photos of front and back.</span>
  </p>
  <p>
    <span style="text-decoration: underline">If you have a passport:</span>
    <span> please provide photos of all pages with personal information (two-page spread on the photo).</span>
  </span>
  <p>
    Photos should be of good quality, in color, and easy to read. Stamps and seals should also be visible.
  </p>
</div>
`;
